"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipWithRelationsSchema = exports.MembershipWithGroupSchema = exports.MembershipSchema = exports.OrganizationSchema = exports.UserSchema = void 0;
const zod_1 = require("zod");
const index_js_1 = require("../Auth/index.js");
exports.UserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    username: zod_1.z.string(),
    email: zod_1.z.string().nullable(),
    displayName: zod_1.z.string().nullable(),
    type: zod_1.z.nativeEnum(index_js_1.UserRecordType),
    auth0UserId: zod_1.z.string().nullable(),
    emailConfirmed: zod_1.z.boolean(),
    createdAt: zod_1.z.coerce.date(),
});
exports.OrganizationSchema = zod_1.z.object({
    id: zod_1.z.string(),
    organizationName: zod_1.z.string(),
    displayName: zod_1.z.string().nullable(),
    createdAt: zod_1.z.coerce.date(),
});
exports.MembershipSchema = zod_1.z.object({
    id: zod_1.z.string(),
    memberId: zod_1.z.string(),
    groupId: zod_1.z.string(),
    role: zod_1.z.nativeEnum(index_js_1.MembershipRole),
    createdAt: zod_1.z.coerce.date(),
});
exports.MembershipWithGroupSchema = exports.MembershipSchema.extend({
    group: exports.OrganizationSchema,
});
exports.MembershipWithRelationsSchema = exports.MembershipSchema.extend({
    member: exports.UserSchema,
    group: exports.OrganizationSchema,
});
//# sourceMappingURL=user-management.types.js.map